import { captureException } from 'client/lib/sentry';

function swallowLoadFailure(err: unknown, what: string) {
  const { statusCode, message } = (err || {}) as { statusCode?: number; message?: string };
  if (statusCode === 401 || statusCode === 402 || statusCode === 403) {
    return undefined;
  }
  captureException(
    err instanceof Error
      ? err
      : Object.assign(new Error(`Failed to load ${what}: ${message || 'unknown error'}`), {
          statusCode,
        }),
  );
  return undefined;
}

/**
 * The overview renders without the check-in card when check-ins cannot be
 * loaded. Members who have lost access get an auth-shaped rejection and that
 * is expected; anything else is a real failure and is reported.
 */
export function swallowCheckinLoadFailure(err: unknown) {
  return swallowLoadFailure(err, 'check-ins');
}

/** The same for the tracker's numbers: the page renders without them. */
export function swallowTrackerLoadFailure(err: unknown) {
  return swallowLoadFailure(err, 'the tracker glance');
}
